import React from 'react';
import PropTypes from 'prop-types';
import { assignmentOptions } from '../helpers';
import RadioGroupField from '../../Fields/RadioGroupField';
import withDependency from '../../Fields/hooks/withDependency';
import { QUESTIONS } from '../constants';

const TrayDesignAssignmentField = ({ options, ...props }) => {
  const availableAssignments = assignmentOptions({
    assignments: options
  });
  const overrideLabel = (
    <>
      <span style={{ color: '#ff0000', fontStyle: 'italic', fontSize: 'smaller' }}>NEW</span>{' '}
      {QUESTIONS[props.name]}
    </>
  );
  return (
    <RadioGroupField options={availableAssignments} {...props} overrideLabel={overrideLabel} />
  );
};

TrayDesignAssignmentField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default withDependency(TrayDesignAssignmentField);
